module.exports = __webpack_public_path__ + "media/src/images/logos/openai-aa7e880bdaeb37a4ca962f25ce54cc82.png";